
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/thank-you",
      function () {
        return require("private-next-pages/contact-us/thank-you/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us/thank-you"])
      });
    }
  